import { createAction, props } from '@ngrx/store';
import { Vault } from '@/app/shared/models/vault.model';
import { PaginationResponse } from '@shared/models/common.model';
import {
  BalanceDistribution,
  RecentActivity,
  VaultWhitelistAssignment,
} from '../models/vault.model';

// Create Actions
export const createVault = createAction(
  '[Vault] Create Vault',
  props<{ name: string }>()
);

export const createVaultSuccess = createAction(
  '[Vault] Create Vault Success',
  props<{ message: string }>()
);

export const createVaultFailure = createAction(
  '[Vault] Create Vault Failure',
  props<{ error: string }>()
);

// Update Actions
export const updateVault = createAction(
  '[Vault] Update Vault',
  props<{ vaultId: string; name: string }>()
);

export const updateVaultSuccess = createAction(
  '[Vault] Update Vault Success',
  props<{ message: string }>()
);

export const updateVaultFailure = createAction(
  '[Vault] Update Vault Failure',
  props<{ error: string }>()
);

// Clear operation success (e.g. when opening edit modal so we only react to the next success)
export const clearOperationSuccess = createAction(
  '[Vault] Clear Operation Success'
);

// Disable Vault Actions
export const disableVault = createAction(
  '[Vault] Disable Vault',
  props<{ vaultId: string }>()
);

export const disableVaultSuccess = createAction(
  '[Vault] Disable Vault Success',
  props<{ message: string; requestId: string; vaultId: string }>()
);

export const disableVaultFailure = createAction(
  '[Vault] Disable Vault Failure',
  props<{ error: string }>()
);

// Enable Vault Actions
export const enableVault = createAction(
  '[Vault] Enable Vault',
  props<{ vaultId: string }>()
);

export const enableVaultSuccess = createAction(
  '[Vault] Enable Vault Success',
  props<{ message: string; requestId: string; vaultId: string }>()
);

export const enableVaultFailure = createAction(
  '[Vault] Enable Vault Failure',
  props<{ error: string }>()
);

// Reset State
export const resetState = createAction('[Vault] Reset State');

// Load Vault Detail Actions
export const loadVaultDetail = createAction(
  '[Vault Detail] Load Vault Detail',
  props<{ vaultId: string }>()
);

export const loadVaultDetailSuccess = createAction(
  '[Vault Detail] Load Vault Detail Success',
  props<{ detail: Vault }>()
);

export const loadVaultDetailFailure = createAction(
  '[Vault Detail] Load Vault Detail Failure',
  props<{ error: string }>()
);

// Clear Vault Detail Action
export const clearVaultDetail = createAction(
  '[Vault Detail] Clear Vault Detail'
);

// Load Balance Distribution Actions
export const loadBalanceDistribution = createAction(
  '[Vault Detail] Load Balance Distribution',
  props<{ vaultId: string }>()
);

export const loadBalanceDistributionSuccess = createAction(
  '[Vault Detail] Load Balance Distribution Success',
  props<{ data: BalanceDistribution }>()
);

export const loadBalanceDistributionFailure = createAction(
  '[Vault Detail] Load Balance Distribution Failure',
  props<{ error: string }>()
);

// Load Recent Activities Actions
export const loadRecentActivities = createAction(
  '[Vault Detail] Load Recent Activities',
  props<{ vaultId: string; page: number; limit: number }>()
);

export const loadRecentActivitiesSuccess = createAction(
  '[Vault Detail] Load Recent Activities Success',
  props<{
    activities: RecentActivity[];
    pagination: PaginationResponse;
  }>()
);

export const loadRecentActivitiesFailure = createAction(
  '[Vault Detail] Load Recent Activities Failure',
  props<{ error: string }>()
);

// Vault whitelist assignments (tab on vault detail)
export const loadVaultWhitelistAssignments = createAction(
  '[Vault Detail] Load Vault Whitelist Assignments',
  props<{ vaultId: string; page: number; limit: number }>()
);

export const loadVaultWhitelistAssignmentsSuccess = createAction(
  '[Vault Detail] Load Vault Whitelist Assignments Success',
  props<{
    assignments: VaultWhitelistAssignment[];
    pagination: PaginationResponse;
  }>()
);

export const loadVaultWhitelistAssignmentsFailure = createAction(
  '[Vault Detail] Load Vault Whitelist Assignments Failure',
  props<{ error: string }>()
);
